<template>
	<div class="flex flex-row gap-4 justify-between mt-4">
		<div v-if="!hideQty && !wishProduct">
			<ProductProductAttributesAddToCartQuantitySelector
				v-model="quantity"
				:min="1"
				:max="stock"
			/>
		</div>
		<button
			class="w-full h-full py-3 md:text-base text-[15px] px-3 rounded-4xl transition-colors ease-in-out duration-200 text-white"
			:class="[
				`${stockStatus?.buttonColor ? stockStatus.buttonColor : 'bg-green-light hover:bg-green-600'}`,
				`${!hideQty && !wishProduct ? 'md:max-w-[316px]' : 'min-h-[50px]'}`,
				`${disableButton ? 'cursor-not-allowed' : 'cursor-pointer'}`
			]"
			data-testid="add-to-cart-button"
			:disabled="cartStore.updating || disableButton"
			@click="handleAddToCart"
		>
			<div v-if="cartStore.updating">
				<div
					class="inline-block h-5 w-5 mr-4 animate-spin rounded-full border-4 border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white"
					role="status"
				></div>
				<span>{{ $t("Adding") }}..</span>
			</div>
			<span v-else>{{ stockStatus?.buttonText || $t("Buy") }}</span>
		</button>
	</div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import type { ProductItem } from "@nwt/norce-pwa/dist/runtime/types/api/product/product";
import type { StockStatusItem } from "~/types/storyblok/storyblok";

interface Props {
	stock: number;
	wishProduct?: ProductItem;
	hideQty?: boolean;
	stockStatus?: StockStatusItem;
}
const { stock, wishProduct, hideQty, stockStatus } = defineProps<Props>();

const cartStore = useCartStore();

// This shop keeps an out-of-stock product buyable unless the Storyblok stock
// status says otherwise, so the whole base rule hangs off that flag — and a
// wishlist quick-add falls back to the plain stock check.
const disableButton = useAddToCartDisabled(() => stock, {
	wishProduct: () => wishProduct,
	gate: () => !!stockStatus?.disableAddToCart,
	fallback: () => stock === 0 && !!stockStatus?.disableAddToCart
});

const quantity = ref(1);

// GTM used to fire inside this template's own cartStore; the store now comes
// from base, which — like every other template — tracks from the press.
const { handleAddToCart } = useAddToCartAction(quantity, () => ({
	wishProduct
}));
</script>
